module.exports = __webpack_public_path__ + "img/PTM.1390b6c7.svg";